"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  yesterday: {
    id: 'xsui.date-picker.preset.yesterday',
    defaultMessage: 'Yesterday'
  },
  week: {
    id: 'xsui.date-picker.preset.week',
    defaultMessage: 'Last week'
  },
  x2week: {
    id: 'xsui.date-picker.preset.x2week',
    defaultMessage: 'Last 2 weeks'
  },
  month: {
    id: 'xsui.date-picker.preset.month',
    defaultMessage: 'Last month'
  },
  clear: {
    id: 'xsui.date-picker.actions.clear',
    defaultMessage: 'Clear'
  },
  apply: {
    id: 'xsui.date-picker.actions.apply',
    defaultMessage: 'Apply'
  },
  ok: {
    id: 'xsui.date-picker.actions.ok',
    defaultMessage: 'Ok'
  }
});

exports["default"] = _default;